import { FieldProps, useFormikContext } from 'formik';
import { ReactElement, useCallback } from 'react';
import { SUPPORT_URL } from 'shared/constants/links';
import UDSelect, { UDSelectProps } from './component';

import styled from '@emotion/styled';
import classNames from 'classnames';
import { Info } from 'lucide-react';
import UDTippy from 'ud-ui/components/tippy';
import UDFormFieldWrapper from '../../wrapper';
import UDInput from '../input/component';
import { UDFormComponentProps } from '../types';

type UDFormSelectProps<isMulti extends boolean> = UDFormComponentProps &
  UDSelectProps<isMulti> & {
    selectComponent?: (props: any) => ReactElement<any, any> | null;
    isAvailable?: boolean;
  };

type Returning = <isMulti extends boolean = false>(props: UDFormSelectProps<isMulti> & { highlight?: boolean }) => JSX.Element;

const UdFormTemplateSelect: Returning = (props) => {
  const { name, containerProps, required, label, labelProps, selectComponent, isAvailable, highlight, ...otherSelectProps } = props;

  const { setFieldValue } = useFormikContext();
  const onChange = useCallback(
    (value: any, isMulti: any) => {
      setFieldValue(name, value);

      if (props.onChange) {
        props.onChange(value, isMulti);
      }
    },
    [name, props, setFieldValue],
  );

  const Component = selectComponent || UDSelect;

  return (
    <UDFormFieldWrapper name={name} containerProps={containerProps} label={label} labelProps={labelProps} required={required}>
      {({ field }: FieldProps<any>) => {
        if (isAvailable === false) {
          const icon = (
            <>
              <Link href={SUPPORT_URL} target="_blank" className={'mr-3'}>
                Оформить подписку
              </Link>
              <UDTippy content="Для бесплатной версии доступен только один шаблон." maxWidth={170}>
                <Info size={20} strokeWidth={1.5} />
              </UDTippy>
            </>
          );

          return (
            <UDInput
              wrapperProps={{
                className: 'w-full',
              }}
              value={'ImGame'}
              style={{ userSelect: 'none', pointerEvents: 'none' }}
              iconProps={{ position: 'icon-right', component: icon }}
            />
          );
        } else if (isAvailable === undefined) {
          return <UDInput value={'Загрузка'} readOnly style={{ userSelect: 'none', pointerEvents: 'none' }} />;
        }
        return (
          <Wrapper className={classNames('w-full', { highlight: highlight })}>
            <Component
              {...otherSelectProps}
              {...field}
              divProps={{
                className: classNames('w-full', otherSelectProps?.className),
              }}
              onChange={onChange}
            />
          </Wrapper>
        );
      }}
    </UDFormFieldWrapper>
  );
};

export default UdFormTemplateSelect;

const Link = styled.a`
  font-family:
    SF Pro Display,
    sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.71px;
  text-align: left;
  color: #007aff;

  &:visited {
    color: #007aff;
  }
`;

const Wrapper = styled.div`
  background: transparent;
  border-radius: 8px;

  &.highlight {
    animation: highlightAnimation 1s ease-in-out 3;
  }

  @keyframes highlightAnimation {
    0% {
      box-shadow: unset;
    }
    50% {
      box-shadow: 0 0 20px 10px #d9b244;
    }
    100% {
      box-shadow: unset;
    }
  }
`;
